module.exports = __webpack_public_path__ + "static/img/AE.76ed8b11.svg";